import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["height"]
const _hoisted_2 = {
  id: "Group_6739",
  "data-name": "Group 6739"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  id: "Rectangle_2583",
  "data-name": "Rectangle 2583",
  width: "24",
  height: "24",
  fill: "none"
}, null, -1)
const _hoisted_4 = {
  id: "Group_6184",
  "data-name": "Group 6184",
  transform: "translate(4.271 3.271)"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'IconSearch',
  props: {
    classStroke: {},
    size: {},
    className: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    id: "Component_450_6",
    "data-name": "Component 450 – 6",
    xmlns: "http://www.w3.org/2000/svg",
    height: _ctx.size || 24,
    viewBox: "0 0 24 24",
    class: _normalizeClass(_ctx.className)
  }, [
    _createElementVNode("g", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("g", _hoisted_4, [
        _createElementVNode("circle", {
          id: "Ellipse_148",
          class: _normalizeClass(`${_ctx.classStroke} svg-stroke`),
          "data-name": "Ellipse 148",
          cx: "7.42",
          cy: "7.42",
          r: "7.42",
          transform: "translate(0 0)",
          fill: "none",
          stroke: "#fff",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2"
        }, null, 2),
        _createElementVNode("line", {
          id: "Line_350",
          class: _normalizeClass(`${_ctx.classStroke} svg-stroke`),
          "data-name": "Line 350",
          x1: "4.365",
          y1: "4.365",
          transform: "translate(13.094 13.094)",
          fill: "none",
          stroke: "#fff",
          "stroke-linejoin": "round",
          "stroke-width": "2"
        }, null, 2)
      ])
    ])
  ], 10, _hoisted_1))
}
}

})